import React, { InputHTMLAttributes, forwardRef } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { Switch } from '../../atoms';
import { cn } from '@jobcost-monorepo/utils';
import { useTranslation } from '@jobcost-monorepo/i18n';

interface Props extends InputHTMLAttributes<HTMLButtonElement> {
  id: string;
  name: string;
  label?: string;
  width?: string;
}

export const SwitchForm = forwardRef<HTMLButtonElement, Props>(
  ({ id, name, label, width = 'w-full', ...rest }, ref) => {
    const { t } = useTranslation('errors');
    const { control, setValue, trigger } = useFormContext();
    const {
      field: { value, onChange },
      formState: { errors },
    } = useController({ control, name, defaultValue: false });
    const error = errors?.[name]?.message ?? '';
    const errorTranslated = t(error as string, { ns: 'errors' });

    const handleChange = (valueInput: boolean) => {
      onChange(valueInput);
      setValue(name, valueInput, { shouldDirty: true, shouldTouch: true });
      trigger(name).then();
    };

    return (
      <div className={cn('flex-col', width)}>
        <div className="size-full flex items-center">
          <Switch
            id={id}
            name={name}
            checked={value}
            onCheckedChange={(value) => handleChange(value)}
            {...rest}
            ref={ref}
          />
          <label
            className={cn(
              'pl-2 text-sm dark:text-white',
              rest.disabled ? 'text-gray-500' : 'text-gray-700',
            )}
          >
            {label}
          </label>
        </div>
        <p
          className="h-4 text-xs my-1 ml-1 text-red overflow-hidden"
          id="error"
        >
          {errorTranslated}
        </p>
      </div>
    );
  },
);

SwitchForm.displayName = 'SwitchForm';

export default SwitchForm;
